import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BASE_URL = "https://dorafshatit.vercel.app";
const HOME_DESCRIPTION =
  "Dora Fshatit është treg online për ushqim të freskët, fruta të freskëta, perime të freskëta dhe shporta nga ferma shqiptare me dorëzim në shtëpi.";

const HOME_KEYWORDS = [
  "Dora Fshatit",
  "Dora e Fshatit",
  "ushqim i freskët",
  "ushqim i fresket",
  "fruta të freskëta",
  "fruta te fresketa",
  "perime të freskëta",
  "perime te fresketa",
  "perime fshati",
  "fruta fshati",
  "ferma shqiptare",
  "shporta me fruta",
  "shporta me perime",
  "ushqim nga ferma",
];

const SCRIPT_ID = "dora-jsonld";

const JsonLd = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    let existing = document.getElementById(SCRIPT_ID);
    if (existing) existing.remove();

    const origin = typeof window !== "undefined" ? window.location.origin : BASE_URL;
    const normalizedPath = pathname === "/" ? "/" : pathname.replace(/\/+$/, "");
    const currentUrl = `${origin}${normalizedPath}`;
    const logoUrl = `${origin}/logo512.png`;

    const organizationSchema = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "@id": `${origin}/#organization`,
      name: "Dora Fshatit",
      alternateName: "Dora e Fshatit",
      url: origin,
      logo: logoUrl,
      description: HOME_DESCRIPTION,
      areaServed: {
        "@type": "Country",
        name: "Albania",
      },
      knowsAbout: [
        "fresh produce",
        "fruit",
        "vegetables",
        "farm baskets",
        "local farms",
      ],
    };

    const websiteSchema = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "@id": `${origin}/#website`,
      url: origin,
      name: "Dora Fshatit",
      inLanguage: ["sq", "en"],
      publisher: {
        "@id": `${origin}/#organization`,
      },
    };

    const groceryStoreSchema = {
      "@context": "https://schema.org",
      "@type": "GroceryStore",
      "@id": `${origin}/#store`,
      name: "Dora Fshatit",
      url: origin,
      image: logoUrl,
      description: HOME_DESCRIPTION,
      priceRange: "$$",
      address: {
        "@type": "PostalAddress",
        addressCountry: "AL",
      },
      areaServed: {
        "@type": "Country",
        name: "Albania",
      },
      hasOfferCatalog: {
        "@type": "OfferCatalog",
        name: "Kategori produktesh",
        itemListElement: [
          {
            "@type": "OfferCatalog",
            name: "Fruta të freskëta",
            url: `${origin}/products`,
          },
          {
            "@type": "OfferCatalog",
            name: "Perime të freskëta",
            url: `${origin}/products`,
          },
          {
            "@type": "OfferCatalog",
            name: "Shporta me fruta",
            url: `${origin}/farms`,
          },
          {
            "@type": "OfferCatalog",
            name: "Shporta me perime",
            url: `${origin}/farms`,
          },
          {
            "@type": "OfferCatalog",
            name: "Produkte fshati",
            url: `${origin}/farms`,
          },
        ],
      },
    };

    const breadcrumbSchema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Ballina",
          item: origin,
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Ferma",
          item: `${origin}/farms`,
        },
        {
          "@type": "ListItem",
          position: 3,
          name: "Produkte",
          item: `${origin}/products`,
        },
      ],
    };

    const homePageSchema = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "@id": `${origin}/#homepage`,
      url: currentUrl,
      name: "Dora Fshatit",
      description: HOME_DESCRIPTION,
      inLanguage: "sq",
      isPartOf: {
        "@id": `${origin}/#website`,
      },
      about: HOME_KEYWORDS.map((keyword) => ({
        "@type": "Thing",
        name: keyword,
      })),
      primaryImageOfPage: {
        "@type": "ImageObject",
        url: logoUrl,
      },
      keywords: HOME_KEYWORDS.join(", "),
    };

    const schemas =
      normalizedPath === "/"
        ? [
            organizationSchema,
            websiteSchema,
            groceryStoreSchema,
            homePageSchema,
            breadcrumbSchema,
          ]
        : [organizationSchema, websiteSchema];

    const el = document.createElement("script");
    el.id = SCRIPT_ID;
    el.type = "application/ld+json";
    el.textContent = JSON.stringify(schemas);
    document.head.appendChild(el);

    return () => {
      const cleanup = document.getElementById(SCRIPT_ID);
      if (cleanup) cleanup.remove();
    };
  }, [pathname]);

  return null;
};

export default JsonLd;
